import { useRef } from 'react'
import { useStore } from '../store'
import { saveProjectFile, loadProjectFile } from '../lib/project'

function ago(ts: number): string {
  const s = Math.floor((Date.now() - ts) / 1000)
  if (s < 60) return `${s}s trước`
  if (s < 3600) return `${Math.floor(s / 60)}p trước`
  return `${Math.floor(s / 3600)}h trước`
}

/** GĐ8 — Dự án: version history + lưu/mở file dự án (.json). */
export function ProjectPanel() {
  const fileRef = useRef<HTMLInputElement>(null)
  const history = useStore((s) => s.history)
  const busy = useStore((s) => s.busy)
  const saveVersion = useStore((s) => s.saveVersion)
  const restoreVersion = useStore((s) => s.restoreVersion)
  const deleteVersion = useStore((s) => s.deleteVersion)
  const setStatus = useStore((s) => s.setStatus)

  return (
    <div className="logopanel">
      <div className="logopanel-head">🗂️ Dự án & Phiên bản</div>

      <div className="proj-actions">
        <button className="btn small" disabled={busy} onClick={() => saveVersion('')}>
          💾 Lưu phiên bản
        </button>
        <button className="btn small ghost" disabled={busy} onClick={saveProjectFile}>
          ⬇ Xuất .json
        </button>
        <button className="btn small ghost" disabled={busy} onClick={() => fileRef.current?.click()}>
          📂 Mở .json
        </button>
      </div>

      {history.length > 0 && (
        <div className="versions">
          {history.map((h) => (
            <div key={h.id} className="ver-row">
              <span className="ver-label" onClick={() => restoreVersion(h.id)} title="Khôi phục">
                {h.label}
              </span>
              <span className="ver-time">{ago(h.createdAt)}</span>
              <button className="mini danger" onClick={() => deleteVersion(h.id)}>
                🗑
              </button>
            </div>
          ))}
        </div>
      )}

      <input
        ref={fileRef}
        type="file"
        accept="application/json,.json"
        hidden
        onChange={async (e) => {
          const f = e.target.files?.[0]
          if (f) setStatus(await loadProjectFile(f))
          e.target.value = ''
        }}
      />
    </div>
  )
}
